/**
 *
 * @param {import('./types').TenderDetails | {}} tenderDetails
 * @returns {boolean|string}
 */
const getParsedTenderType = (tenderDetails) => tenderDetails.isBCCAsDefault && 'U';

/**
 *
 * @param {import('./types').mcomUserInfo | import('./types').bcomUserInfo | null} userInfo
 * @returns {import('./types').userInfoParsed}
 */
// eslint-disable-next-line import/prefer-default-export
export function userInfoParser(userInfo) {
  if (!userInfo) {
    return null;
  }

  const {
    tierInfo,
    defaultTenderType: tenderType = '',
    encryptedLoyaltyId = '',
    cardDefaultToWallet = false,
    isLtyIdLinked = false,
    tenderDetails = {},
  } = userInfo.loyalty ?? userInfo;

  return {
    encryptedLoyaltyId,
    cardDefaultToWallet,
    isLtyIdLinked,
    tierInfo,
    defaultTenderType: tenderType || getParsedTenderType(tenderDetails) || 'V',
  };
}
